var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 6,
    cy: 6,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 0C4.81331 0 3.65328 0.351894 2.66658 1.01118C1.67989 1.67047 0.910851 2.60754 0.456725 3.7039C0.00259971 4.80025 -0.11622 6.00666 0.115291 7.17054C0.346802 8.33443 0.918247 9.40352 1.75736 10.2426C2.59648 11.0818 3.66557 11.6532 4.82946 11.8847C5.99335 12.1162 7.19975 11.9974 8.2961 11.5433C9.39246 11.0891 10.3295 10.3201 10.9888 9.33342C11.6481 8.34672 12 7.18669 12 6C11.997 4.40964 11.3638 2.88529 10.2393 1.76073C9.11471 0.63617 7.59036 0.0030496 6 0ZM8.175 7.51731C8.26167 7.60481 8.31029 7.72299 8.31029 7.84615C8.31029 7.96931 8.26167 8.08749 8.175 8.175C8.08678 8.2603 7.96887 8.30798 7.84616 8.30798C7.72344 8.30798 7.60553 8.2603 7.51731 8.175L6 6.65192L4.48269 8.175C4.39448 8.2603 4.27656 8.30798 4.15385 8.30798C4.03113 8.30798 3.91322 8.2603 3.825 8.175C3.73833 8.08749 3.68971 7.96931 3.68971 7.84615C3.68971 7.72299 3.73833 7.60481 3.825 7.51731L5.34808 6L3.825 4.48269C3.7514 4.39302 3.71379 4.27917 3.71948 4.1633C3.72517 4.04743 3.77376 3.93782 3.85579 3.85579C3.93782 3.77376 4.04743 3.72517 4.1633 3.71948C4.27917 3.71379 4.39302 3.7514 4.48269 3.825L6 5.34808L7.51731 3.825C7.60698 3.7514 7.72083 3.71379 7.8367 3.71948C7.95257 3.72517 8.06218 3.77376 8.14421 3.85579C8.22624 3.93782 8.27483 4.04743 8.28052 4.1633C8.28621 4.27917 8.2486 4.39302 8.175 4.48269L6.65192 6L8.175 7.51731Z",
    fill: "#E75113"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.caf1143c8a512b2b716cb821a6ed69a8.svg";
export { ForwardRef as ReactComponent };